"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterMethodLabel = exports.dateFilterOpts = exports.dropdownFilterOpts = exports.numberFilterOpts = exports.textFilterOpts = exports.commonFilterOpts = exports.filterInputTypeOpts = exports.AlignmentOpts = exports.SortDirectionOpts = void 0;
/**
 * Sort options for data table.
 */
var SortDirectionOpts;
(function (SortDirectionOpts) {
    SortDirectionOpts["ASC"] = "asc";
    SortDirectionOpts["DESC"] = "desc";
    SortDirectionOpts["DEFAULT"] = "default";
})(SortDirectionOpts || (exports.SortDirectionOpts = SortDirectionOpts = {}));
/**
 * Alignment options for data table columns.
 */
var AlignmentOpts;
(function (AlignmentOpts) {
    AlignmentOpts["LEFT"] = "left";
    AlignmentOpts["RIGHT"] = "right";
    AlignmentOpts["CENTER"] = "center";
})(AlignmentOpts || (exports.AlignmentOpts = AlignmentOpts = {}));
/**
 * Input types for filter options in data table.
 */
var filterInputTypeOpts;
(function (filterInputTypeOpts) {
    filterInputTypeOpts["TEXT"] = "text";
    filterInputTypeOpts["NUMBER"] = "number";
    filterInputTypeOpts["DATE"] = "date";
    filterInputTypeOpts["DROPDOWN"] = "dropdown";
})(filterInputTypeOpts || (exports.filterInputTypeOpts = filterInputTypeOpts = {}));
/**
 * Common filter options for text, number, and dropdown filters.
 */
var commonFilterOpts;
(function (commonFilterOpts) {
    commonFilterOpts["EQUALS"] = "equals";
    commonFilterOpts["NOT_EQUALS"] = "notEquals";
})(commonFilterOpts || (exports.commonFilterOpts = commonFilterOpts = {}));
/**
 * Filter options for text filters.
 */
var textFilterOpts;
(function (textFilterOpts) {
    textFilterOpts["STARTS_WITH"] = "startsWith";
    textFilterOpts["CONTAINS"] = "contains";
    textFilterOpts["ENDS_WITH"] = "endsWith";
})(textFilterOpts || (exports.textFilterOpts = textFilterOpts = {}));
/**
 * Filter options for number filters.
 */
var numberFilterOpts;
(function (numberFilterOpts) {
    numberFilterOpts["GREATER_THAN"] = "greterThan";
    numberFilterOpts["LESS_THAN"] = "lessThan";
    numberFilterOpts["GREATER_THAN_OR_EQUAL"] = "greaterThanOrEqual";
    numberFilterOpts["LESS_THAN_OR_EQUAL"] = "lessThanOrEqual";
})(numberFilterOpts || (exports.numberFilterOpts = numberFilterOpts = {}));
/**
 * Filter options for dropdown filters.
 */
var dropdownFilterOpts;
(function (dropdownFilterOpts) {
    dropdownFilterOpts["IN"] = "in";
    dropdownFilterOpts["NOT_IN"] = "notIn";
})(dropdownFilterOpts || (exports.dropdownFilterOpts = dropdownFilterOpts = {}));
/**
 * Filter options for date filters.
 */
var dateFilterOpts;
(function (dateFilterOpts) {
    dateFilterOpts["AFTER"] = "after";
    dateFilterOpts["BEFORE"] = "before";
    dateFilterOpts["BETWEEN"] = "between";
    dateFilterOpts["NOT_BETWEEN"] = "notBetween";
})(dateFilterOpts || (exports.dateFilterOpts = dateFilterOpts = {}));
exports.FilterMethodLabel = {
    contains: 'Contains',
    doesNotContain: 'Does Not Contain',
    equals: 'Equals',
    notEquals: 'Does Not Equal',
    startsWith: 'Starts With',
    endsWith: 'Ends With',
    greterThan: 'Greater Than',
    greaterThanOrEqual: 'Greater Than Or Equal',
    lessThan: 'Less Than',
    lessThanOrEqual: 'Less Than Or Equal',
    empty: 'Empty',
    notEmpty: 'Not Empty',
    after: 'After',
    before: 'Before',
    between: 'Between',
    notBetween: 'Not Between',
};
//# sourceMappingURL=constants.js.map